import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";


@Injectable()
export class CheckingMechanismService {
    constructor(private http: HttpClient) { }

    checkEmail() {
        return this.http.get(
            this.getBaseUrl() + "/api/checkingmechanism/checkemail"
        );
    }

    checkDBConnection() {
        return this.http.get(
            this.getBaseUrl() + "/api/checkingmechanism/checkdbconnection"
        );
    }

    checkNLog(level: number) {
        return this.http.get(
            this.getBaseUrl() + "/api/checkingmechanism/checkNLog/" + level
        );
    }

    checkServerHealth() {
        return this.http.get(
            this.getBaseUrl() + "/api/checkingmechanism/CheckServerHealthInformation"
        );
    }

    private getBaseUrl() {
        return (location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "") );
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/checking-mechanism.service.ts